export default {
  methods: {
    redirectToAttraction(payload) {
      this.$router.push({ name: 'attraction', params: { slug: payload.value }})
    },
    formatAttractions(attractions) {
      return attractions.map(attraction => {
        return {
          id: attraction.slug,
          name: attraction.content.en.title.toLowerCase()
        }
      })
    },
  }
}